import IconButton from '../Common/IconButton/button';
import './style.scss';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer-wrapper">
                    <div className="footer-contact">
                        <div className="contact-item">
                            <IconButton iconUrl={'/icons/phone.svg'} width={25} height={25} />
                            <a href="tel:+38(097)0230023">+38 (097) 023 0023</a>
                        </div>
                        <div className="contact-item">
                            <a href="viber://chat?number=+380970230023"><IconButton width={'24px'} height={'24px'} iconUrl={'/icons/viber-icon.svg'} alt='viber' /></a>
                            <a href="https://t.me/+380970230023"><IconButton width={'24px'} height={'24px'} iconUrl={'/icons/telegram-icon.svg'} alt='telegram' /></a>
                        </div>
                    </div>
                    <div className="footer-contact">
                        <div className="contact-item"><IconButton iconUrl={'/icons/time.svg'} width={25} height={25} />
                            Пн. - Нд. 9:00 - 20:00</div>
                        <div className="contact-item"><IconButton iconUrl={'/icons/place.svg'} width={25} height={25} />Житомир, Київська 77, 4-й поверх, 9 кабінет</div>
                    </div>
                </div>

            </footer>
        </>
    )
}

export default Footer;